import { useQuery } from "@tanstack/react-query";
import { _axios } from "../utils/axios";

export function useBlockedPlotsViewer(search?: string) {
    return useQuery({
        queryKey: ["blocked-plots-viewer", search],
        queryFn: () =>
            _axios.get("/blocked-plot-viewer", { params: { search } }),
        select: (d) => d.data.data,
    });
}